import { Trip } from './trip';
import { OutletTripRange } from './outlet-trip-range';

export class OutletTripsSearch {
    ranges: OutletTripRange[] = [];
    serviceNotConfigured: boolean;
}